export default function cleanUpNotes(rawNotes) {
  if (!rawNotes) {
    return []
  }

  let englishSummary = ''
  const notes = rawNotes.reduce((acc, note) => {
    // This regex matches any notes that start with English text followed by a colon so we can remove it
    const key = note.match(/^[a-z /]+: /i)

    // If the note starts with "English Summary: ", we want to remove "English Summary: " and move the rest to the bottom of the list of notes
    if (key?.[0] === 'English Summary: ') {
      englishSummary = note.replace(key, '')
      return acc
    }

    return [...acc, note.replace(key, '')]
  }, [])

  if (englishSummary) {
    notes.push(englishSummary)
  }

  return notes
}
